// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"ProfileMenuItem__menuItem___2jmoT","locationIcon":"ProfileMenuItem__locationIcon___3Od8z","tpb":"ProfileMenuItem__tpb___3rBnO"};